import React, { useRef, useEffect, useState } from 'react';
import './BlogPostDetail.scss';
import { BiComment, BiShow } from 'react-icons/bi';
import { AddComment, AddCommentReply, GetBlogbyPostID, GetBlogCategories, GetBlogPostPreview, GetCommentsList, GetFeaturedPostList, GetPostList, GetPostListByCategories, UpdateCommentLike, UpdateCommentReplyLike, UpdateCommentUnLike } from 'services/blogs/blogs';
import { errorResponse, failResponse, normalEncryptData } from "config/config";
import parse from "html-react-parser";
import { useParams, Link, useNavigate } from "react-router-dom";
import { GoogleIcon } from "assets/icons";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { toast } from "react-hot-toast";
import useButtonLoader from "hooks/useButtonLoader";
import LikeButton from 'components/post-blog-components/likebutton';
import UnLikeButton from 'components/post-blog-components/unlikebutton';
import { FaPlay, FaPause, FaStop, FaVolumeMute, FaVolumeUp, FaRedo } from "react-icons/fa";
import { VscDebugRestart } from "react-icons/vsc";
import { MdPlayCircleOutline } from "react-icons/md";
import ReactionToolTip from 'components/post-blog-components/reactiontooltip';
import NotFound from 'pages/not-found/NotFound';







const BlogDetailPreview = () => {

    const [posts, setPosts] = useState([]);
    const [postContent, setpostContent] = useState({});
    const [postCount, setpostCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [blogcategories, setblogcategories] = useState([]);
    const { postid } = useParams();
    const [total, setTotal] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const loginCallbackRef = useRef(null);


    const [allPosts, setAllPosts] = useState([]);
    const postsPerPage = 5;
    const [signinGoogle, setSigninGoogle] = useState(false);
    const [CommentAvailable, setCommentAvailable] = useState(false);
    const [googlename, setgooglename] = useState("");
    const [googleemail, setgoogleemail] = useState("");
    const [likedComments, setLikedComments] = useState({});
    const [sparkleCommentId, setSparkleCommentId] = useState(null);
    const [likeCounts, setLikeCounts] = useState({});
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        const getPostListData = async () => {
            try {
                const res = await GetPostList();
                if (res.code === 200) {
                    setPosts(res.data.Posts.rows || []);
                } else {
                    failResponse(res);
                }
            } catch (err) {
                errorResponse(err);
            } finally {
                setLoading(false);
            }
        };
        getPostListData();
    }, []);


    useEffect(() => {
        const getBlogByPostID = async () => {
            try {
                const res = await GetBlogPostPreview({ id: postid });
                if (res.code === 200) {
                    setpostContent(res.data.postContent || []);
                    setpostCount(res.data.postcount || 0);
                    setCommentAvailable(res.data.postContent?.comments);
                } else {
                    failResponse(res);
                }
            } catch (err) {
                errorResponse(err);
            } finally {
                setLoading(false);
            }
        };
        getBlogByPostID();
    }, []);


    useEffect(() => {
        const getBlogCategories = async () => {
            try {
                const res = await GetBlogCategories();
                if (res.code === 200) {
                    setblogcategories(res.data.blogCategories || []);
                } else {
                    failResponse(res);
                }
            } catch (err) {
                errorResponse(err);
            } finally {
                setLoading(false);
            }
        };
        getBlogCategories();
    }, []);

    const navigate = useNavigate();

    const featuredCoursesNavigate = async (id) => {
        try {
            setLoading(true);
            const res = await GetBlogPostPreview({ id });
            if (res.code === 200) {
                    setpostContent(res.data.postContent || []);
                    navigate(`/blog-post-detail/${id}`);
                    setActiveAction("");
                    speechSynthesis.cancel()
                    await getcomments(id) // ✅ navigate after setting content
            } else {
                failResponse(res);
            }
        } catch (err) {
            errorResponse(err);
        } finally {
            setLoading(false);
        }
    };
    const getcomments = async (id) => {
        try {

            const res = await GetCommentsList({ postid: id });
            if (res.code === 200) {
                const comments = res.data.PostComments.rows || [];

                // Set comments list
                setcommentslist(comments);
                setcommentflag(res.data.commentedFlag);

                // Extract like counts
                const counts = {};
                comments.forEach(comment => {
                    counts[comment.id] = comment.likes || 0;
                });
                setLikeCounts(counts);

                // Optional: Initialize likedComments if your API supports it
                const liked = {};
                comments.forEach(comment => {
                    liked[comment.id] = false; // or get from API if available
                });
                setLikedComments(liked);

            } else {
                failResponse(res);
            }
        } catch (err) {
            errorResponse(err);
        } finally {
            setLoading(false);
        }
    };

    const BlogCategoryCoursesNavigate = async (id, name) => {
        try {
            setLoading(true);
            const res = await GetPostListByCategories({ page: 1, limit: postsPerPage, categoryid: id });
            if (res.code === 200) {
                const initialPosts = res.data.PostsByCategories.rows || [];
                setAllPosts(initialPosts);
                setTotal(res.data.PostsByCategories.count || 0);
                setHasMore(res.data.PostsByCategories.count > 5);
                navigate(`/blog-posts/${id}/${name}`);  // ✅ navigate after setting content
            } else {
                failResponse(res);
            }
        } catch (err) {
            errorResponse(err);
        } finally {
            setLoading(false);
        }
    };




    // const posts = [
    //     {
    //         title: 'Understanding Indian Polity',
    //         date: 'May 2025',
    //         content: 'Explore the constitutional framework and key amendments.',
    //         image: 'https://images.unsplash.com/photo-1512820790803-83ca734da794?auto=format&fit=crop&w=600&q=80',
    //     },
    //     {
    //         title: 'Economic Survey Insights',
    //         date: 'April 2025',
    //         content: 'Summary of the latest Economic Survey with exam relevance.',
    //         image: 'https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&w=600&q=80',
    //     },
    //     {
    //         title: 'Answer Writing Tips',
    //         date: 'March 2025',
    //         content: 'How to structure answers for maximum marks.',
    //         image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=600&q=80',
    //     },
    //     {
    //         title: 'Mastering CSAT Techniques',
    //         date: 'February 2025',
    //         content: 'Boost your aptitude and comprehension skills effectively.',
    //         image: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=600&q=80',
    //     },
    //     {
    //         title: 'India Year Book Highlights',
    //         date: 'January 2025',
    //         content: 'Condensed insights from key government publications.',
    //         image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvaw7TQPDH96mmt_5tvISR65wWusUF6bLFaA&s',
    //     }
    // ];

    // const featuredPosts = [
    //     { featuredpost: 'Economic Survey Insights', featuredpostcontent: 'Explore the constitutional framework and key amendments.' },
    //     { featuredpost: 'Answer Writing Tips', featuredpostcontent: 'Summary of the latest Economic Survey with exam relevance.' },
    //     { featuredpost: 'How to structure answers for maximum marks.', featuredpostcontent: 'latest Economic Survey with exam relevance.' },
    // ];

    const featuredCategories = [
        { featuredcategory: "Polity & Governance" },
        { featuredcategory: "Economy" },
        { featuredcategory: "Geography" },
        { featuredcategory: "History & Culture" },
        { featuredcategory: "Environment & Ecology" },
        { featuredcategory: "Science & Technology" },
        { featuredcategory: "Current Affairs" }
    ];

    const [featuredPosts, setFeaturedPosts] = useState([]);
    const [commentslist, setcommentslist] = useState([]);
    const [commentflag, setcommentflag] = useState(false);


    const [currentSlide, setCurrentSlide] = useState(0);

    // Auto slide effect every 4 seconds
    useEffect(() => {
        const slideInterval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % posts.length);
        }, 4000);

        return () => clearInterval(slideInterval); // cleanup on unmount
    }, [posts.length]);

    useEffect(() => {
        const getFeaturedPostListData = async () => {
            try {
                const res = await GetFeaturedPostList();
                if (res.code === 200) {
                    setFeaturedPosts(res.data.Featuredposts.rows || []);
                } else {
                    failResponse(res);
                }
            } catch (err) {
                errorResponse(err);
            } finally {
                setLoading(false);
            }
        };
        getFeaturedPostListData();
    }, []);

    // Make it a standalone function within the component
    const getCommentsListData = async () => {
        try {
            const res = await GetCommentsList({ postid: postid, email: googleemail || "" });
            if (res.code === 200) {
                const comments = res.data.PostComments || [];

                // Set comments list
                setcommentslist(comments);
                setcommentflag(res.data.commentedFlag);

                // Extract like counts
                const counts = {};
                comments.forEach(comment => {
                    counts[comment.id] = comment.likes || 0;
                });
                setLikeCounts(counts);

                // Optional: Initialize likedComments if your API supports it
                const liked = {};
                comments.forEach(comment => {
                    liked[comment.id] = false; // or get from API if available
                });
                setLikedComments(liked);

            } else {
                failResponse(res);
            }
        } catch (err) {
            errorResponse(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // console.log("Updated commentflag:", commentflag);
    }, [commentflag]);


    // Call it from useEffect
    useEffect(() => {
        getCommentsListData();
    }, []);


    const login = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            try {
                const { data } = await axios.get(
                    `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenResponse.access_token}`,
                    {
                        headers: {
                            Authorization: `Bearer ${tokenResponse.access_token}`,
                            Accept: "application/json",
                        },
                    }
                );

                if (data) {
                    setSigninGoogle(true);
                    setgooglename(data.name);
                    setgoogleemail(data.email);
                    localStorage.setItem("googlemail", data.email);
                    localStorage.setItem("googlename", data.name);
                    localStorage.setItem("signinflag", true);
                    await getCommentsListData();

                    // Save comment ID in ref/state and handle in effect or next step
                }
            } catch (err) {
                console.log("Google login error:", err);
            }
        },
    });
    useEffect(() => {
        setgoogleemail(googleemail)
    }, [googleemail]);
    const loginforReply = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            try {
                const { data } = await axios.get(
                    `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenResponse.access_token}`,
                    {
                        headers: {
                            Authorization: `Bearer ${tokenResponse.access_token}`,
                            Accept: "application/json",
                        },
                    }
                );

                if (data) {
                    setSigninGoogle(true);
                    setgooglename(data.name);
                    setgoogleemail(data.email);
                    localStorage.setItem("googleemail", data.email);
                    localStorage.setItem("googlename", data.name);
                    localStorage.setItem("signinflag", true);
                    await getCommentsListData();

                    // Save comment ID in ref/state and handle in effect or next step
                    if (loginCallbackRef.current) {
                        loginCallbackRef.current();
                        loginCallbackRef.current = null; // reset after use
                    }
                }
            } catch (err) {
                console.log("Google login error:", err);
            }
        },
    });
    useEffect(() => {
        setgoogleemail(googleemail)
    }, [googleemail]);

    const loginForReply = (commentId) => {
        loginCallbackRef.current = () => {
            setReplyclicked(true);
            setReplyingTo(commentId);
        };
        loginforReply(); // This calls the `useGoogleLogin` hook’s trigger function
    };


    const [formData, setFormData] = useState({
        comment: ''
    });

    const [errors, setErrors] = useState({});
    const [buttonRef, setButtonLoading] = useButtonLoader("Post Comment", true);
    const [replyingTo, setReplyingTo] = useState(null);
    const [replyclicked, setReplyclicked] = useState(false);
    const [replyText, setReplyText] = useState("");


    let utter = null;

    const [activeAction, setActiveAction] = useState(null);
    const [readingProgress, setReadingProgress] = useState(0); // 0 to 100


    const readblog = (postContent) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = postContent;
        const textOnly = tempDiv.innerText;

        // Cancel current speech
        speechSynthesis.cancel();

        // Wait a tiny bit to let cancel fully register before speaking again
        setTimeout(() => {
            const utter = new SpeechSynthesisUtterance(textOnly);
            utter.rate = 1;

            // Reset icon color after speech ends
            utter.onend = () => {
                setActiveAction(null);
            };

            speechSynthesis.speak(utter);
            setActiveAction("play");
        }, 100); // 100ms delay to ensure cancel is fully applied
    };




    const pauseReading = () => {
        if (speechSynthesis.speaking && !speechSynthesis.paused) {
            speechSynthesis.pause();
            setActiveAction("pause");
        }
    };

    const resumeReading = () => {
        if (speechSynthesis.paused) {
            speechSynthesis.resume();
            setActiveAction("resume");
        }
    };

    const restartReading = (postContent) => {
        speechSynthesis.cancel();
        readblog(postContent);
        setActiveAction("restart");
    };



    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setErrors("");
        setFormData({ ...formData, [name]: value });
    };

    const handleValidation = () => {
        const newErrors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!formData.comment.trim()) newErrors.comment = "Please enter your comment";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (handleValidation()) {
            setErrors({});
            setButtonLoading(true);

            try {
                const res = await AddComment({
                    postid: postid,
                    name: googlename,
                    email: googleemail,
                    comment: formData.comment
                });

                if (res.code === 200) {
                    toast.success(res.message);
                    setFormData({ comment: "" });
                    await getCommentsListData()
                } else {
                    setFormData({ comment: "" });
                    failResponse(res);
                }
            } catch (err) {
                errorResponse(err);
            } finally {
                setButtonLoading(false);
            }
        }
    };

    const handleSubmitCommentReply = async (commentid, comment) => {

        setButtonLoading(true);

        try {
            const res = await AddCommentReply({
                postid: postid,
                name: googlename,
                email: googleemail,
                commentid: commentid,
                comment: comment
            });

            if (res.code === 200) {
                toast.success(res.message);
                setFormData({ comment: "" });
                await getCommentsListData()
            } else {
                setFormData({ comment: "" });
                failResponse(res);
            }
        } catch (err) {
            errorResponse(err);
        } finally {
            setButtonLoading(false);
        }

    };

    const handleLike = async (commentId, newcount) => {
        try {
            const res = await UpdateCommentLike({
                postid: postid,
                likecount: newcount,
                commentid: commentId,
            });

            if (res.code === 200) {
                await getCommentsListData() // Optional: refresh to sync
            } else {
                failResponse(res);
            }
        } catch (err) {
            errorResponse(err);
        } finally {
            setButtonLoading(false);
        }


    };
    const handleUnLike = async (commentId, newcount) => {
        try {

            const res = await UpdateCommentUnLike({
                postid: postid,
                unlikecount: newcount,
                commentid: commentId,
            });

            if (res.code === 200) {
                await getCommentsListData() // Optional: refresh to sync
            } else {
                failResponse(res);
            }
        } catch (err) {
            errorResponse(err);
        } finally {
            setButtonLoading(false);
        }
    };
    const handleReplyLike = async (commentId, newcount, replyid) => {
        try {
            const res = await UpdateCommentReplyLike({
                postid: postid,
                likecount: newcount,
                commentid: commentId,
                replyid: replyid
            });

            if (res.code === 200) {
                await getCommentsListData() // Optional: refresh to sync
            } else {
                failResponse(res);
            }
        } catch (err) {
            errorResponse(err);
        } finally {
            setButtonLoading(false);
        }


    };


    useEffect(() => {
        const checkIPChange = async () => {
            try {
                const res = await fetch('https://api.ipify.org?format=json');
                const data = await res.json();
                const currentIP = data.ip;


                const storedIP = localStorage.getItem("user_ip");

                if (storedIP && storedIP !== currentIP) {
                    // IP has changed, so remove the items
                    localStorage.removeItem("googlename");
                    localStorage.removeItem("googleemail");
                    localStorage.removeItem("signinflag");
                }

                // Update or set the current IP
                localStorage.setItem("user_ip", currentIP);
            } catch (error) {
                console.error("Failed to fetch IP address", error);
            }

            // Continue with existing logic
            const storedName = localStorage.getItem("googlename");
            const storedEmail = localStorage.getItem("googleemail");
            const SigninFlag = localStorage.getItem("signinflag");

            if (storedName) setgooglename(storedName);
            if (storedEmail) setgoogleemail(storedEmail);
            if (SigninFlag) setSigninGoogle(SigninFlag);
        };
        speechSynthesis.cancel();

        checkIPChange();
    }, []);


    return (
        <div className="blocks-page">


            {/* Main Content */}
            <div className="content">
                {/* Left: Blog Posts */}
                <div className="content-left">

                    <div className="blog-post">
                        <div className="blog-post-details scrollable-content">
                            <div className='blog-post-detail-content'>
                                <small className="blog-post-addedby">
                                    By <span style={{ color: "#e7272d", cursor: "pointer" }} onClick={() => navigate(`/blog-post`)}>
                                        {postContent?.addedby || "Shubhra Ranjan"}
                                    </span>
                                </small>

                                <small className="blog-post-date">
                                    {postContent?.publisheddate
                                        ? `At ${new Date(postContent?.publisheddate).toLocaleDateString('en-GB', {
                                            day: '2-digit',
                                            month: 'long',
                                            year: 'numeric',
                                        })}`
                                        : 'Not Published'}
                                </small>

                                <small className="blog-post-categoryname">
                                    <span
                                        style={{ color: "#e7272d", cursor: "pointer" }}
                                        onClick={() => navigate(`/blog-posts/8/${postContent?.categoryname}`)}
                                    >
                                        {postContent?.categoryname || 'Current Affairs'}
                                    </span>
                                </small>


                                <div className="audio-control-wrapper">
                                    <div className="audio-control-box">
                                        <button onClick={() => readblog(postContent?.description)} title="Play">
                                            <MdPlayCircleOutline
                                                size={22}
                                                color={activeAction === "play" ? "#e7272d" : "#534b4b"}
                                            />
                                        </button>
                                        <button onClick={pauseReading} title="Pause">
                                            <FaPause
                                                size={15}
                                                color={activeAction === "pause" ? "#e7272d" : "#534b4b"}
                                            />
                                        </button>
                                        <button onClick={resumeReading} title="Resume">
                                            <FaPlay
                                                size={14}
                                                color={activeAction === "resume" ? "#e7272d" : "#534b4b"}
                                            />
                                        </button>
                                        <button onClick={() => restartReading(postContent?.description)} title="Restart">
                                            <VscDebugRestart
                                                size={18}
                                                color={activeAction === "restart" ? "#e7272d" : "#534b4b"}
                                            />
                                        </button>
                                    </div>

                                </div>
                            </div>



                            <h1 className="blog-post-title">{postContent.title}</h1>
                            <img src={postContent?.poster} alt={postContent?.poster} className="blog-post-detail-image" />
                            <div className="blog-post-body" style={{ marginTop: "15px" }}>
                                {parse(postContent?.description || "")}
                            </div>
                            <div className="blog-post-stats">
                                <span className="blog-post-stat">
                                    <BiComment size={18} style={{ marginRight: '5px' }} /> 20
                                </span>
                                <span className="blog-post-stat">
                                    <BiShow size={18} style={{ marginLeft: '15px', marginRight: '5px' }} /> 30
                                </span>
                            </div>


                        </div>
                    </div>
                    <div>
                        {postContent && (
                            <ReactionToolTip
                                postid={postid}
                                like={postContent.likes}
                                dislikes={postContent.dislikes}
                                views={postContent.views}
                                comments={postCount || 0}
                            />
                        )}


                    </div>
                    {CommentAvailable === true && (<div>
                        {signinGoogle === false && (
                            <button
                                onClick={login}
                                style={{
                                    padding: "5px 9px",
                                    backgroundColor: "white",
                                    color: "#4971B2",
                                    border: "1px solid #4971B2",
                                    borderRadius: "35px",
                                    cursor: "pointer",
                                    fontWeight: "500",
                                    marginTop: "10px",
                                    marginLeft: "5px"
                                }}
                            >
                                <img
                                    src={GoogleIcon}
                                    alt="Google"
                                    style={{ width: "15px" }}
                                />
                                <span style={{ fontSize: "13px", marginLeft: "10px" }}>Sign in with Google to Post Comment</span>
                            </button>
                        )}
                    </div>)}



                    {CommentAvailable === true && (<div
                        className="comment-section"
                        style={signinGoogle === false ? { padding: "6px 30px 30px 30px" } : {}}
                    >

                        {signinGoogle === true && !commentflag && (
                            <form onSubmit={handleSubmit} className='simple-comment-form'>
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Enter Name"
                                    className='student-name-input'
                                    value={googlename}
                                    disabled
                                    onChange={handleInputChange}
                                />
                                {errors.name && <span style={{ color: 'red' }}>{errors.name}</span>}

                                <textarea
                                    name="comment"
                                    placeholder="Enter Comment"
                                    value={formData.comment}
                                    onChange={handleInputChange}
                                    rows={3}
                                    maxLength={300}
                                />
                                {errors.comment && <span style={{ color: 'red' }}>{errors.comment}</span>}

                                <div style={{ textAlign: "right", fontSize: "12px", color: "#555" }}>
                                    {formData.comment.length}/300
                                </div>

                                <button type="submit" ref={buttonRef}>Post Comment</button>
                            </form>
                        )}



                        {/* Comment List */}
                        <div className="comment-list">
                            <div className="comment-heading">Comments</div>

                            <div className="all-comments" style={signinGoogle === false ? { maxHeight: "380px" } : {}}>
                                {commentslist.length === 0 ? (
                                    <div style={{
                                        textAlign: "center",
                                        padding: "30px",
                                        backgroundColor: "#f9f9f9",
                                        borderRadius: "8px",
                                        color: "#666",
                                        fontStyle: "italic",
                                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)"
                                    }}>
                                        <div style={{ fontSize: "24px", marginBottom: "10px" }}>🗨️</div>
                                        <div style={{ fontSize: "16px" }}>No comments yet. Be the first to share your thoughts!</div>
                                    </div>
                                ) : (
                                    commentslist.map((comment, index) => (
                                        <div className="comment-item" key={comment.id}>
                                            <p><strong>{comment.name}</strong></p>
                                            <p>{comment.comment}</p>

                                            <div className="comment-actions">
                                                <LikeButton
                                                    likedCount={comment.likes}
                                                    // onLikeChange={(newCount) => {
                                                    //     handleLike(comment.id, newCount)
                                                    // }}
                                                />


                                                <UnLikeButton
                                                    likedCount={comment.unlikes || 0}
                                                    // onLikeChange={(newCount) => {
                                                    //     handleUnLike(comment.id, newCount)
                                                    // }} 
                                                    />
                                                <button
                                                    onClick={() => {
                                                        if (signinGoogle) {
                                                            setReplyclicked(true);
                                                            setReplyingTo(comment.id);
                                                        } else {
                                                            loginForReply(comment.id);
                                                        }
                                                    }}
                                                >
                                                    💬 Reply
                                                </button>


                                            </div>

                                            {replyingTo === comment.id && (
                                                <div style={{ marginTop: "10px", textAlign: "right" }}>

                                                    <div style={{ marginTop: "10px" }}>
                                                        <input
                                                            type="text"
                                                            placeholder="Add a public reply..."
                                                            value={replyText}
                                                            onChange={(e) => setReplyText(e.target.value)}
                                                            style={{
                                                                width: "100%",
                                                                border: "none",
                                                                borderBottom: "1px solid #ccc",
                                                                outline: "none",
                                                                padding: "6px 4px",
                                                                fontSize: "14px",
                                                                marginBottom: "10px",
                                                            }}
                                                        />

                                                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                                                            <button
                                                                onClick={() => {
                                                                    setReplyText("");
                                                                    setReplyclicked(false);
                                                                    setReplyingTo(null);

                                                                }}
                                                                style={{
                                                                    padding: "5px 12px",
                                                                    backgroundColor: "#f1f1f1",
                                                                    border: "none",
                                                                    borderRadius: "4px",
                                                                    cursor: "pointer",
                                                                    fontWeight: "500",
                                                                    color: "#333",
                                                                }}
                                                            >
                                                                Cancel
                                                            </button>
                                                            <button
                                                                onClick={() => {
                                                                    handleSubmitCommentReply(comment.id, replyText);
                                                                    setReplyText("");
                                                                    setReplyclicked(false);
                                                                    setReplyingTo(null);
                                                                }}

                                                                style={{
                                                                    padding: "5px 12px",
                                                                    backgroundColor: "#4971B2",
                                                                    color: "white",
                                                                    border: "none",
                                                                    borderRadius: "4px",
                                                                    cursor: "pointer",
                                                                    fontWeight: "500",
                                                                }}
                                                            >
                                                                Reply
                                                            </button>
                                                        </div>
                                                    </div>


                                                </div>
                                            )}

                                            {comment.replies && comment.replies.length > 0 && (
                                                <div className="comment-replies" style={{ marginLeft: "20px", marginTop: "10px", paddingLeft: "10px" }}>
                                                    {comment.replies.map((reply, rIndex) => (
                                                        <div key={rIndex} className="comment-reply" style={{ marginBottom: "10px", marginTop: "15px" }}>
                                                            <p style={{ marginBottom: "4px" }}>
                                                                <strong>{reply.name}</strong>
                                                            </p>
                                                            <p style={{ fontSize: "14px", color: "#555", marginBottom: "8px" }}>{reply.comment}</p>
                                                            <div className='reply_buttons'>
                                                                <div className="like-wrapper">
                                                                    <LikeButton
                                                                        likedCount={reply.likes}
                                                                        onLikeChange={(newCount) => {
                                                                            handleReplyLike(comment.id, newCount, reply.id)
                                                                        }}
                                                                    />


                                                                </div>
                                                                <UnLikeButton />
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}


                                        </div>

                                    ))
                                )}

                            </div>
                        </div>


                    </div>)}






                </div>

                {/* Right: Comments */}
                <div className="content-right">
                    <div className='featuredposts'>
                        <h4 className="featuredposts-heading">Featured Posts</h4>
                        <hr />
                        {featuredPosts.slice(0, 4).map(({ id, title, shortdescription, poster }) => (
                            <div
                                key={id}
                                onClick={() => featuredCoursesNavigate(id)}
                                style={{ textDecoration: 'none', color: 'inherit' }}
                            >

                                <div className="featuredpost" style={{ display: "flex", gap: "12px", cursor: "pointer" }}>
                                    <img
                                        src={poster}
                                        alt={title}
                                        className="banner-img banner-img-2"
                                        style={{ width: "160px", borderRadius: "4px", height: "100px" }}
                                    />
                                    <div className='featuredpost-text'>
                                        <p className="featuredpost-text-heading">{title}</p>
                                        <p className="featuredpost-text-content">{shortdescription}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <br />
                    <div className='featuredcategories'>
                        <h4 className="featuredcategories-heading">Categories</h4>
                        <hr />
                        <ul className="featuredcategory-list" >
                            {blogcategories.map((category) => (
                                <li key={category.categoryid} className="featuredcategory-item" onClick={() => BlogCategoryCoursesNavigate(category.categoryid, category.title)} style={{ cursor: "pointer" }}>
                                    <span className="category-title">{category.title}</span>
                                    <span className="subcategory-count">({category.postcounts || 0})</span>
                                </li>
                            ))}
                        </ul>

                    </div>



                    <div className="latest-posts">
                        <h4 className="latest-posts-heading">Latest Posts</h4>
                        <hr />
                        <div className="latest-post-slide">
                            <img
                                src={posts[currentSlide]?.poster}
                                alt={posts[currentSlide]?.title}
                                className="latest-post-image"
                            />
                            <div className="latest-post-details">
                                <h5 className="latest-post-title">{posts[currentSlide]?.title}</h5>
                                <p className="latest-post-content">{posts[currentSlide]?.shortdescription}</p>
                            </div>
                        </div>
                    </div>
                    <div className="join-community">
                        <h4 className="sidebar-heading">Join the Community</h4>
                        <hr />
                        <h5>Shubhra Ranjan IAS Study</h5>
                        <a href="https://t.me/sriasofficial" target="_blank" className="telegram-btn" rel="noopener noreferrer">
                            <div className="icon-circle">
                                <img src="https://upload.wikimedia.org/wikipedia/commons/8/82/Telegram_logo.svg" alt="Telegram" />
                            </div>
                            Join our Telegram Channel
                        </a>
                    </div>
                    {/* <div className="get-latest-news">
                        <h4 className="sidebar-heading">Get Latest News</h4>
                        <hr />
                        <p style={{ fontSize: "14px", fontWeight: "600", color: "black" }}>Why has the US often excited climate pacts?</p>
                        <img style={{ width: "100%" }} src="http://srcurrentaffairs.s3.amazonaws.com/NewsOfTheDay/US%20Extend%20(1).jpg" alt="Telegram" />

                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default BlogDetailPreview;
